// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2NcCH","buttons":"SendReceipts_buttons__1htrJ","email":"SendReceipts_email__2SNvH","bookApptTitle":"SendReceipts_bookApptTitle__1OpZo"};